import i18n from '@/locale/index'

export default [
  {
    path: '/applyId',
    name: 'applyId',
    component: () => import('../../views/applyId/index.vue'),
    meta: {
      title: i18n.global.t('applyId.title')
    }
  },
  {
    path: '/applyIdCard',
    name: 'applyIdCard',
    component: () => import('../../views/applyIdCard/index.vue'),
    meta: {
      title: i18n.global.t('applyId.C9')
    }
  },
]
